import BlockHeader from "../../Headers/BlockHeader";
import JobListingResultBlock from "./JobListingResultBlock";

const JobListingBlock = () => {
  return (
    <>
      <div className="d-block mb-3">
        <BlockHeader title={"Job Posting"} />
      </div>
      <JobListingResultBlock />
    </>
  );
};

export default JobListingBlock;
